import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useDropzone } from "react-dropzone"
import { DateTimePicker } from "react-advance-jalaali-datepicker"
import { useRequestProcessor } from "../../api/requestProcessor"
import { uploadImage, uploadVideo } from "../../api/upload-files"
import { getSingleWorkshop, storeSingleWorkshops, updateSingleWorkshops } from "../../api/workshops"
import Loading from "../../components/loading/loading"
import { getAllProvinces, getProvinceCities } from "../../api/city-province"
import { domainName } from "../../constants/site"

import makeAnimated from 'react-select/animated';
import Select from "react-select"
import { getAllCategoriesWithType } from "../../api/categories"

import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"



const Require = () => {
    return <span className="text-red-500">*</span>
}

const EditWorkshop = () => {

    const [name, setName] = useState("")
    const [capacity, setCapacity] = useState(0)
    const [city, setCity] = useState(0)
    const [selectedProvince, setSelectedProvince] = useState(0)

    const [category, setCategory] = useState([])
    const [period, setPeriod] = useState("")
    const [price, setPrice] = useState(0)
    const [timeStamp, setTimeStamp] = useState()
    const [isVideo, setIsVideo] = useState(true)
    const [bannerUrl, setBannerUrl] = useState("")
    const [coverUrl, setCoverUrl] = useState("")
    const [videoData, setVideoData] = useState({
        url: "",
        extenstion: ""
    })
    const [aparatUrl, setAparatUrl] = useState("")
    const [gallery, setGallery] = useState([])
    const [newGallery, setNewGallery] = useState([])
    const [description, setDescription] = useState("")
    const [convertedContent, setConvertedContent] = useState(null);


    const { workshop_id } = useParams()
    const navigate = useNavigate()

    const { Query, Mutate } = useRequestProcessor()


    const { data: workshopData, isLoading } = Query(
        ["getSingleWorkshop"],
        () => getSingleWorkshop(workshop_id)
    )

    const { data: provinces } = Query(
        ['getAllProvinces'],
        () => getAllProvinces(),
    );
    const { data: cities } = Query(
        ['getProvinceCities', selectedProvince],
        () => getProvinceCities(selectedProvince),
        { enabled: !!selectedProvince }
    );

    const { mutate: mutateWorkshop } = Mutate(
        "updateSingleWorkshop",
        updateSingleWorkshops,
        {
            onSuccess: (data) => {
                toast.success(data.message + " تا چند ثانیه دیگر به صفحه اصلی منتقل خواهید شد.", {
                    autoClose: 2500,
                    progress: false,
                })
                setTimeout(() => { navigate("/admin/workshop") }, 3000)
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { data: categoryData, isLoading: discountLoading, refetch } = Query(
        ['getAllCategoryByType', "workshops"],
        () => getAllCategoriesWithType("workshops")
    );


    const { mutate: mutateBanner } = Mutate(
        "uploadBannerImage",
        uploadImage,
        {
            onSuccess: (data) => {
                successfulHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { mutate: mutateGallery } = Mutate(
        "uploadgalleryImage",
        uploadImage,
        {
            onSuccess: (data) => {
                toast.success("عکس با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                setNewGallery(prev => [...prev, {
                    thumb: data.images.thumb
                }])
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { mutate: mutateCover } = Mutate(
        "uploadCoverImage",
        uploadImage,
        {
            onSuccess: (data) => {
                toast.success("عکس با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                setCoverUrl(data.images.thumb)
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { mutate: mutateVideo } = Mutate(
        "uploadVideo",
        uploadVideo,
        {
            onSuccess: (data) => {
                toast.success("ویدیو با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                setVideoData({ url: data.data.filePath, extenstion: data.data.fileExtension })
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    // DROPZONE CONFIG

    const onDrop = useCallback(acceptedFiles => {
        for (let files of acceptedFiles) {
            let formData = new FormData();
            formData.append("images", files)
            mutateGallery(formData)
        }
    }, [])

    const onDropThumb = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        mutateBanner(formData)
    }, [])

    const onDropCover = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        mutateCover(formData)
    }, [])
    const onDropVideo = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("video", acceptedFiles[0])
        mutateVideo(formData)
    }, [])


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    });

    const { getRootProps: getThumbRootprops, getInputProps: getThumbInputProps, isDragActive: isThumbDragActive } = useDropzone({
        onDrop: onDropThumb, maxFiles: 1, multiple: false, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    });
    const { getRootProps: getCoverRootprops, getInputProps: getCoverInputProps, isDragActive: isCoverDragActive } = useDropzone({
        onDrop: onDropCover, maxFiles: 1, multiple: false, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    });
    const { getRootProps: getVideoRootprops, getInputProps: getVideoInputProps, isDragActive: isVideoDragActive } = useDropzone({
        onDrop: onDropVideo, maxFiles: 1, multiple: false, accept: {
            'video/*': [],
        }
    });



    function onDescriptionHandler(event) {
        setDescription(event.target.value)
    }
    function change(unix, formatted) {
        setTimeStamp(unix)
        // setDate(formatted);
    }

    function successfulHandler(res) {
        setBannerUrl(res.images.thumb);
        toast.success(res.message)
    }

    async function onSubmitHandler(e) {
        e.preventDefault();
        let newData = {
            id: workshop_id,
            data: {
                title: name,
                capacity: capacity,
                price: price,
                period: period,
                city_id: city,
                body: convertedContent,
                province_id: selectedProvince,
                event_time: timeStamp,
                category_id: category?.map(el => el.value),
                description: description,
                banner: {
                    thumb: bannerUrl
                },
                cover_image: {
                    thumb: coverUrl
                },
                gallery_images: gallery,
                video_type: isVideo ? "video" : "aparat",
                video: isVideo ?
                    {
                        filePath: videoData.url ? { path: videoData.url } : null,
                        fileExtension: videoData.extenstion ?? null
                    }
                    :
                    {
                        htmlCode: aparatUrl ?? null
                    }
                ,
            }
        }
        mutateWorkshop(newData)
    }

    function propertiesHandler(data) {

        setName(data?.data?.title)
        setCapacity(data?.data?.capacity)
        setPrice(data?.data?.price)
        setPeriod(data?.data?.period)
        setSelectedProvince(data?.data?.city?.province)
        setCity(data?.data?.city?.id)
        setTimeStamp(data?.data?.event_time)
        setCategory(data?.data?.categories.map(el => ({ label: el.title, value: el.id })))
        setDescription(data?.data?.description)
        setConvertedContent(data?.data?.body)

        data?.data?.files.forEach(key => {
            if (key.type === "cover") {
                setCoverUrl(key.file.thumb)
            }
            else if (key.type === "banner") {
                setBannerUrl(key.file.thumb)
            }
            else if (key.type === "aparat") {
                setAparatUrl(key.file.htmlCode)
            }
            else if (key.type === "video") {
                setVideoData({ url: key?.file?.path })
            }
        });
        setGallery(data?.data?.gallery?.file)
    }


    useEffect(() => {
        propertiesHandler(workshopData)
    }, [workshopData])



    const animatedComponents = makeAnimated();
    function handleOnChange(data) {
        setCategory(data)
    }

    if (isLoading) return <Loading />

    return (
        <Layout >
            <MainPageLayout backButton sectionTitle={"مشخصات ورک شاپ :"} title={"تصحیح ورک شاپ"} >
                <form onSubmit={onSubmitHandler}>
                    <div className="flex">
                        <div className='flex flex-col my-4 w-full'>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>نام ورک شاپ :<Require /></p>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} className=' form-input !w-3/4' placeholder='نام ورک شاپ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>ظرفیت ورک شاپ :<Require /></p>
                                <input type="number" value={capacity} onChange={(e) => setCapacity(e.target.value)} className=' form-input' placeholder='ظرفیت' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>تاریخ و زمان برگزاری :<Require /></p>
                                <DateTimePicker format="jYYYY/jMM/jDD HH:mm" controlValue onChange={change} containerClass="form-input date-picker-bg wsm:!w-fit"
                                    cancelOnBackgroundClick customClass="cs" placeholder={timeStamp ? new Date(timeStamp * 1000).toLocaleString('fa-IR') : "تاریخ را انتخاب کنید  "} className='form-input w-full' />
                                {/* <p className="pr-4 pt-2">{(new Date(date)).getTime()}</p> */}
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>مدت زمان برگزاری : (به همراه نوع زمان)<Require /></p>
                                <input type="text" value={period} onChange={(e) => setPeriod(e.target.value)} className=' form-input' placeholder='مدت زمان ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>انتخاب محل برگزاری :<Require /></p>
                                <div className="flex">
                                    <select value={selectedProvince} onChange={e => setSelectedProvince(e.target.value)} className=" wsm:!w-full border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                        <option selected disabled >انتخاب استان</option>
                                        {
                                            provinces?.data.map(el => (
                                                <option value={el.id} >{el.name}</option>
                                            ))
                                        }
                                    </select>

                                    <select value={city} disabled={!selectedProvince} onChange={e => setCity(e.target.value)} className=" mr-4 wsm:!w-full border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                        <option selected disabled hidden>انتخاب شهر</option>
                                        {
                                            cities?.data?.map(el => (
                                                <option value={el.id} >{el.name}</option>
                                            ))
                                        }
                                    </select>

                                </div>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>قیمت ورک شاپ :<Require /></p>
                                <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} className=' form-input' placeholder='قیمت' />
                            </div>
                            <div className='flex flex-col my-3 ml-4'>
                                <p className='pr-3 pb-1'>انتخاب دسته بندی :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                    onChange={handleOnChange} closeMenuOnSelect={false}
                                    isMulti options={categoryData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                    value={category}

                                />
                            </div>
                            <div className='flex flex-col my-3 ml-4'>
                                <p className='pr-3 pb-1'>توضیح ورک شاپ:</p>
                                <div className='flex form-input !w-full items-center '>
                                    <input value={description} onChange={onDescriptionHandler} type="text" className='form-input !w-full' placeholder='توضیح مختصر درباره بلاگ ' />
                                    <div className={`flex basis-1/4 justify-center border ${description?.length > 180 ? "!bg-red-500 text-white" : "text-green-500"} border-black rounded-xl py-2 mr-2 bg-white`}>180 / {description?.length} </div>
                                </div>
                            </div>
                            {/* <div class="flex-col  w-full ">
                                <p>وضعیت تخفیف :</p>
                                <div className="mx-10 items-center flex wsm:!mx-0 mt-2">
                                    <p>فعال</p>
                                    <label class="relative inline-flex  cursor-pointer mx-2">
                                        <input type="checkbox" value={isActive} onChange={(e) => setIsActive(prev => !prev)} class="sr-only peer" />
                                        <div class={`w-11 h-6  rounded-full peer ${isActive ? "bg-sky-300" : "bg-gray-200"}  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                    </label>
                                    <p>غیر فعال</p>
                                </div>
                            </div> */}
                        </div>
                        <div className="w-full flex flex-col">

                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'>انتخاب عکس بنر :<Require /></p>

                                <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getThumbRootprops()}>
                                    <input
                                        {...getThumbInputProps()} />
                                    {
                                        <p> فایل را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className="flex justify-center my-4">
                                    <img src={bannerUrl && domainName + bannerUrl} className="w-[150px]" alt="" />
                                </div>
                            </div>

                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'>انتخاب عکس کاور :<Require /></p>

                                <form className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getCoverRootprops()}>
                                    <input
                                        {...getCoverInputProps()} />
                                    {
                                        <p> فایل را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className="flex justify-center my-4">
                                    <img src={coverUrl && domainName + coverUrl} className="w-[150px]" alt="" />
                                </div>
                            </div>
                            <div className="flex flex-col mb-4">
                                <div className="flex justify-between text-center items-center">
                                    <p className='pr-3 pb-1'>انتخاب ویدیو ورک شاپ :(اختیاری)</p>
                                    <div className="mx-10 items-center flex wsm:!mx-0 m-2">
                                        <p>آپارات</p>
                                        <label class="relative inline-flex  cursor-pointer mx-2">
                                            <input type="checkbox" value={isVideo} onChange={(e) => setIsVideo(prev => !prev)} class="sr-only peer" />
                                            <div class={`w-11 h-6  rounded-full peer bg-sky-300  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                        </label>
                                        <p>فایل ویدیو</p>
                                    </div>
                                </div>
                                {
                                    isVideo ?
                                        <form className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getVideoRootprops()}>
                                            <input
                                                {...getVideoInputProps()} />
                                            {
                                                <p> فایل را انتخاب یا به اینجا بکشید</p>
                                            }
                                        </form>
                                        :
                                        <div className='flex flex-col my-3'>
                                            <p className='pr-3 pb-1'>لینک کد آپارات :</p>
                                            <input type="text" value={aparatUrl} onChange={(e) => setAparatUrl(e.target.value)} className=' form-input !w-full' placeholder='لینک را جایگذاری کنید' />
                                        </div>
                                }
                                <div className="flex justify-center my-4">
                                    <video src={videoData.url && domainName + videoData.url.substring(1)} className="w-[150px]" alt="" />
                                </div>
                            </div>

                            {/* <div className="flex flex-col mr-3 mb-6">
                                <p className='pr-3 pb-1'>انتخاب عکس های گالری :(اختیاری)</p>

                                <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    {
                                        <p> فایل ها را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className='!grid grid-cols-4 mt-4 [&>*:nth-child(1)]:border-b [&>*:nth-child(2)]:border-b [&>*:nth-child(3)]:border-b [&>*:nth-child(4)]:border-b'>
                                    {
                                        gallery?.map(el => (
                                            <div className="w-full bg-gray-100  justify-center items-center">
                                                <img src={domainName + el?.file?.thumb} alt="" />
                                            </div>
                                        ))
                                    }
                                    {
                                        newGallery?.map(el => (
                                            <div className="w-full bg-gray-100  justify-center items-center">
                                                <img src={domainName + el?.thumb} alt="" />
                                            </div>
                                        ))
                                    }


                                </div>
                            </div> */}
                            {/* <div className="w-full bg-gray-100  justify-center items-center galleryImage_list">
                                        <div className=" galleryCard__background blur-sm !grayscale !rounded-none bg-[url(https://images.freeimages.com/images/large-previews/321/sunflower-in-bulgaria-1641774.jpg)]" >
                                        </div>
                                        <p className="text-white  absolute top-0 w-full flex justify-center items-center h-full">
                                            18+ عکس دیگر
                                        </p>
                                    </div> */}
                        </div>
                    </div>
                    <div className="flex flex-col my-3">
                        <p className='pr-3 pb-1'>متن ورک شاپ :</p>
                        <CKEditor
                            editor={ClassicEditor}

                            data={convertedContent ?? ""}
                            config={{
                                language: {
                                    ui: "en",
                                    content: "ar"
                                },
                            }}
                            onReady={editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setConvertedContent(data);
                            }}

                        />
                    </div>
                    <p className='pr-3 text-sm'>متاتگ های وبسایت بر اساس کلمات نوشته شما ساخته میشود</p>

                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default EditWorkshop